import { pagesPath } from "@/utils/pages-path";
import Link from "next/link";
import { LuUserRound } from "react-icons/lu";
import { MdOutlineMedicalInformation } from "react-icons/md";

/**
 * 窓口支払額・自己負担額の説明モーダルコンテンツ
 * isRegularInsured: 一般被保険者かどうか（falseの場合は任意継続・被扶養者）
 */
export const PriceExplanationDialogContent = ({
  isRegularInsured,
}: {
  isRegularInsured: boolean;
}) => {
  return (
    <div className="space-y-4 text-sm">
      <div>
        <h3 className="flex items-center gap-1 font-bold">
          <MdOutlineMedicalInformation className="h-4 w-4" />
          窓口支払額
        </h3>
        <p className="mt-1 text-monotone-7">
          健診機関の窓口で実際にお支払いいただく金額です。
        </p>
      </div>
      <div>
        <h3 className="flex items-center gap-1 font-bold">
          <LuUserRound className="h-4 w-4" />
          自己負担額
        </h3>
        <p className="mt-1 text-monotone-7">
          {isRegularInsured
            ? "当組合からの補助金や事業所負担額を差し引いた後の、ご自身でご負担いただく金額です。"
            : "当組合からの補助金を差し引いた後の、ご自身でご負担いただく金額です。"}
        </p>
      </div>
      <div className="border-t border-monotone-3 pt-4">
        <h3 className="font-bold">自己負担額と窓口支払額の差額について</h3>
        {isRegularInsured ? (
          <p className="mt-1 text-monotone-7">
            東振協契約健診機関を受診する場合、健診コースで発生する差額は事業所負担となりますので、事業所へご請求ください。オプション検査で発生する差額は、当組合の補助分になります。当組合にて自動計算してお振込みいたします。
          </p>
        ) : (
          <p className="mt-1 text-monotone-7">
            東振協契約健診機関を受診する場合、差額は当組合の補助分になります。当組合にて自動計算して被保険者の銀行口座へお振込みいたします。
            <Link
              href={pagesPath.members.account.setting.$url().path}
              className="text-primary-6 underline"
            >
              アカウント設定画面
            </Link>
            より銀行口座のご登録をお願いいたします。
          </p>
        )}
      </div>
    </div>
  );
};
